export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <div className="text-xs uppercase tracking-widest text-[#CCFF00]">About Next Gen Spotless</div>
      <h1 className="font-display text-4xl mt-2">Luxury service. Community roots.</h1>
      <p className="text-zinc-300 mt-6 leading-relaxed">
        Next Gen Spotless is a young, community-driven mobile auto detailing business.
        We bring premium detailing directly to your driveway - saving you time and delivering results
        you'd expect from a high-end shop.
      </p>
      <p className="text-zinc-300 mt-4 leading-relaxed">
        Our "Book & Save Together" program lets neighborhoods, workplaces, churches, and organizations
        pool their bookings for better pricing - and more time for us to focus on great work.
      </p>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card-surface p-6">
          <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Contact</div>
          <div className="font-display text-2xl mt-2">Reach out</div>
          <div className="text-zinc-300 mt-3 text-sm space-y-2">
            <div>
              <a href="tel:+17045939023" data-testid="about-phone" className="hover:text-[#CCFF00]">
                Call or text: 704-593-9023
              </a>
            </div>
            <div>
              <a href="mailto:NextGenSpotless1@gmail.com" data-testid="about-email" className="hover:text-[#CCFF00] break-all">
                NextGenSpotless1@gmail.com
              </a>
            </div>
            <div>
              <a href="https://www.instagram.com/nextgenspotless" target="_blank" rel="noopener noreferrer"
                data-testid="about-instagram" className="hover:text-[#CCFF00]">
                Instagram @nextgenspotless
              </a>
            </div>
          </div>
        </div>
        <div className="card-surface p-6">
          <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Service Area</div>
          <div className="font-display text-2xl mt-2">Mobile & flexible</div>
          <p className="text-zinc-400 mt-2 text-sm">We come to homes, workplaces, and community sites.</p>
        </div>
      </div>
    </div>
  );
}
